import { createAction, props } from '@ngrx/store';

export const TermsConditionsActionTypes = {
    SET_DSC_ACCEPTANCE_REQUIRED: '[TERMS CONDITIONS] SET_DSC_ACCEPTANCE_REQUIRED',
    SET_CHECK_ALL_TERMS_AND_CONDITIONS: '[TERMS CONDITIONS] SET_CHECK_ALL_TERMS_AND_CONDITIONS',
    OPEN_DOCUMENT: '[TERMS CONDITIONS] OPEN_DOCUMENT',
    OPEN_PRIVACY_POLICY: '[TERMS CONDITIONS] OPEN_PRIVACY_POLICY',
};

export const SetDscAcceptanceRequired = createAction(
    TermsConditionsActionTypes.SET_DSC_ACCEPTANCE_REQUIRED,
    props<{ acceptanceRequired: boolean }>()
);

export const OpenDocument = createAction(
    TermsConditionsActionTypes.OPEN_DOCUMENT,
    props<{ name: string }>()
);

export const OpenPrivacyPolicy = createAction(
    TermsConditionsActionTypes.OPEN_PRIVACY_POLICY,
    props<{ layer?: string }>(),
);

export const SetCheckAllTermsAndConditions = createAction(
    TermsConditionsActionTypes.SET_CHECK_ALL_TERMS_AND_CONDITIONS,
    props<{ checkAllTermsAndConditions: boolean }>()
);
